import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoadingSpinner } from '../../shared/components/feedback';
import MainLayout from '../../shared/components/layout/MainLayout';
import { ProtectedRoute } from '../../routes/ProtectedRoute';
import { AccessControlWrapper } from '../../routes/AccessControlWrapper';
import { ToastProvider } from '../../shared/context/ToastContext';
import { CustomerProvider } from '../../features/onboarding/context/CustomerContext';
import { publicRoutes, privateRoutes } from './routes.config';

/**
 * AppRouter Component
 * 
 * Main routing configuration with:
 * - Lazy loading for code splitting
 * - Suspense boundaries for loading states
 * - Protected routes for authentication
 * - Access control for admin routes
 */
export const AppRouter = () => {
  return (
    <Suspense fallback={<LoadingSpinner fullScreen message="Loading..." />}>
      <Routes>
        {/* Public routes - no authentication required */}
        {publicRoutes.map((route) => (
          <Route 
            key={route.path} 
            path={route.path} 
            element={<route.element />} 
          />
        ))}

        {/* Private routes - require authentication */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AccessControlWrapper>
                <ToastProvider>
                  <CustomerProvider>
                    <Routes>
                      <Route path="/" element={<MainLayout />}>
                        {privateRoutes.map((route) => {
                          // Use index for home route, otherwise use the path as-is
                          if (route.path === '/') {
                            return (
                              <Route
                                key="index"
                                index
                                element={<route.element />}
                              />
                            );
                          }
                          return (
                            <Route
                              key={route.path}
                              path={route.path}
                              element={<route.element />}
                            />
                          );
                        })}
                      </Route>
                    </Routes>
                  </CustomerProvider>
                </ToastProvider>
              </AccessControlWrapper>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};
